import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LinkedInOAuth from "./LinkdingLoginnew";
import CustomButton from "./customlogin";
import { NavLink } from "react-router-dom";
import AppleLogin from "./AppleLogin";
import TwitterOauthButton from "./Twitter";
import { Divider, Form, Input, Button, message } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import { login, socialLogin } from "../../redux/slice/authSlice";


const LoginForm = () => {
  const [isChecked, setIsChecked] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, error } = useSelector((state) => state.auth);

  const handleCheckboxChange = (e) => {
    e.stopPropagation();
    setIsChecked(!isChecked);
    setErrorMessage("");
  };

  const handleCardClick = () => {
    console.log("click");
    if (!isChecked) {
      setErrorMessage("Please agree to the terms by checking the checkbox.");
    } else {
      setErrorMessage("");
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const credentials = {
        email: values.email,
        password: values.password
      };
      
      const result = await dispatch(login(credentials));
      
      if (login.fulfilled.match(result)) {
        message.success("Login successful!");
        setTimeout(() => {
          navigate("/dashboard");
        }, 500);
      } else if (login.rejected.match(result)) {
        message.error(result.payload || "Login failed. Please check your credentials.");
      }
    } catch (error) {
      message.error("Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="log-form">
      {/* Email/Password Login Form */}
      <Form
        form={form}
        name="login"
        onFinish={onFinish}
        layout="vertical"
        className="email-login-form"
      >
        <Form.Item
          name="email"
          rules={[
            { required: true, message: "Please enter your email" },
            { type: "email", message: "Please enter a valid email" }
          ]}
        >
          <Input
            prefix={<MailOutlined />}
            placeholder="Email Address"
            size="large"
            className="login-input"
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[
            { required: true, message: "Please enter your password" }
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Password"
            size="large"
            className="login-input"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={loading || status === "loading"}
            className="login-submit-btn"
            block
          >
            Sign In
          </Button>
        </Form.Item>
      </Form>

      <Divider>OR continue with</Divider>

      <div className="form-check d-flex align-items-center ps-0" onClick={(e) => e.stopPropagation()}>
        <input
          className="form-check-input ms-0"
          type="checkbox"
          id="flexCheckDefault"
          checked={isChecked}
          onChange={handleCheckboxChange}
          onClick={(e) => e.stopPropagation()}
        />
        <label className="error-message ms-4" htmlFor="flexCheckDefault">
          I agree to the <NavLink to="/">Terms</NavLink> of Use and
          to receive marketing email messages from Poll Sphere, and I accept the{" "}
          <NavLink to="/">Privacy Policy</NavLink>.
        </label>
      </div>
      {errorMessage && (
        <div className="error-message text-danger mt-2">{errorMessage}</div>
      )}
 
      {!isChecked ? (
        <div className="login-btns-wrapper mt-3">
          <button className="login-btn" onClick={handleCardClick}>
            <span>
              <img src="./images/login1.png" alt="Google" />
            </span>{" "}
            Continue with Google
          </button>
          <button className="login-btn" onClick={handleCardClick}>
            <span>
              <img src="./images/login3.png" alt="Apple" />
            </span>
            Continue with Apple
          </button>
          <button className="login-btn" onClick={handleCardClick}>
            <span>
              <img src="./images/login2.png" alt="LinkedIn" />
            </span>
            Continue with LinkedIn
          </button>
          <button className="login-btn" onClick={handleCardClick}>
            <span>
              <img src="./images/twitter.png" alt="Twitter" />
            </span>{" "}
            Continue with Twitter
          </button>
        </div>
      ) : (
        <div className="login-btns-wrapper mt-3">
          <CustomButton disabled={!isChecked} onClick={handleCardClick} />
          <AppleLogin disabled={!isChecked} onClick={handleCardClick} />
          <LinkedInOAuth disabled={!isChecked} onClick={handleCardClick} />
          <TwitterOauthButton disabled={!isChecked} onClick={handleCardClick} />
        </div>
      )}
    </div>
  );
};

export default LoginForm;
